import { action, observable } from 'mobx'

export class AuditStore {
  @observable returnDetail = null

  @action setReturnDetail = (user) => {
    this.returnDetail = user
  }
}
